import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/UserUnfollow.svg'

export const IconUserUnfollow = IconSVG as IconComponent
